// extracted by mini-css-extract-plugin
export default {"button":"NavigationButton_button__xvV51","white":"NavigationButton_white__KYBes","outline":"NavigationButton_outline__RwkjE"};